<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    黄木岗站<br>
站点介绍<br>
黄木岗站位于笋岗西路和华富路交接处，沿环形匝道南北向布置，车站东北侧主要有体育中心及相关的配套设施；西北侧主要有笔架山公园，城市绿化管理处、市二医院及华富村北区等；西南侧主要是海馨苑小区等；东南侧为深圳市实验学校；车站主体以象牙白和浅绿色为主；该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:32	23:12	7号线	3分35秒	5分55秒<br>
太安	06:17	23:44	7号线	3分35秒	5分55秒<br>
岗厦北	06:37	23:52	14号线	4分30秒	6分15秒<br>
沙田	06:03	23:33	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:31	23:12	7号线	4分钟	5分55秒<br>
太安	06:16	23:44	7号线	4分钟	5分55秒<br>
岗厦北	06:52	23:52	14号线	5分25秒	6分15秒<br>
沙田	06:03	23:33	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:32	00:12	7号线	4分钟	5分55秒<br>
太安	06:16	00:44	7号线	4分钟	5分55秒<br>
岗厦北	06:52	00:52	14号线	5分钟	6分15秒<br>
沙田	06:03	00:33	14号线	5分钟	6分15秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
笋岗西路南侧、深圳市实验学校中学部、长城花园<br><br>
B出入口:<br>
笋岗西路北侧、体育大厦、深圳市体育馆、深圳市证监局<br><br>
C出入口:<br>
深圳市第二人民医院、深圳市城管局绿化管理处、市政设计大厦、深圳市血液中心<br><br>
D出入口:<br>
华富路南侧、华强北路北侧、百花六路、深圳市福田区百花小学、海馨苑<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 体育馆<br>
深圳北站-东部华侨城旅游专线、302路、323路、333路、357路、E05路、E11区间线、E20路、M165路、M203路、M329路、W401路、W414、路高峰专线12<br><br>
C出入口:<br>
公交站名： 市二医院1<br>
216路、M207路、M454路、N12路、12路、58路、79路、102路、213路、11路<br><br>
C出入口:<br>
公交站名： 市二医院2<br>
11路、12路、58路、79路、102路、213路、216路、M207路、N12路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shisihaoxian",
          title: "14号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>